const getSelectedRoomAndTenancy = ({
  rooms = [],
  id,
  ignoreAvailable = false,
}: {
  rooms: any;
  id: number | string;
  ignoreAvailable?: boolean;
}) => {
  let selectedTenancy: any = null;
  const selectedRoom = rooms.find((room: any) => {
    if (room.available || ignoreAvailable) {
      if (room.id == id) {
        return true;
      }

      const tenancy = (room.active_children || room.active_children_with_filters)?.find(
        (child: any) => child.id == id || `${room.id}${child.id}` == id,
      );
      if (tenancy) {
        selectedTenancy = tenancy;
        return true;
      }
    }
    return false;
  });

  return { selectedRoom, selectedTenancy };
};

export default getSelectedRoomAndTenancy;
